module.exports = __webpack_public_path__ + "img/pro_13.326bafd0.jpg";